/* eslint-disable max-len */
import React from "react";
import styled from "styled-components";
import Icon from "components/icons";

const OuterWrapper = styled.div`
  border: 1px solid #eef5f5;
  border-radius: 16px;
  box-shadow: 0px 2px 12px 0px #b6eaeb66;
  margin: 2rem 0 0 0;
  padding: 0.9rem;
  max-width: 100%;
  background-color: ${({ theme }) => theme.themeColors.white};
  display: grid;
  grid-template-columns: 0.5fr 2fr;
  grid-template-rows: 1fr;
  gap: 0.5rem;
  min-height: 5.625rem;
  position: relative;

  svg {
    grid-column: 1 / 2;
    grid-row: 1/2;
  }

  ${({ theme }) => theme.mq.md`
    grid-template-columns: 2fr 1.5fr;
    gap: 3rem;
    margin: 3.5rem 0 6rem 0;
    
    svg {
      grid-column: 2 /3;
      position: absolute;
      top: -70px;
      right: 10px;
    }
  `}
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-self: center;
  width: auto;
  grid-column: 2 /3;

  ${({ theme }) => theme.mq.md`
    align-items: flex-start;
    grid-column: 1 / 2;
  `}
`;

const Title = styled.h5`
  font-size: 1rem;
  font-weight: 600;
  margin: 0 0 0.5rem 0;
  color: ${({ theme }) => theme.themeColors.darkGreen1};
`;

const Subtitle = styled.p`
  color: ${({ theme }) => theme.themeColors.darkGreen4};
  font-size: 0.875rem;
  margin: 0;
  line-height: 1.2;
`;

const MobileIconWrapper = styled.div`
  display: inherit;
  grid-column: 1 / 2;
  grid-row: 1/2;

  ${({ theme }) => theme.mq.md`
    display: none;
  `}
`;

const DesktopIconWrapper = styled.div`
  display: none;

  ${({ theme }) => theme.mq.md`
    display: inherit;
    grid-column: 2 /3;
  `}
`;

function Incentive() {
  return (
    <OuterWrapper>
      <TextWrapper>
        <Title>Sign up now to get a $100 gift card!</Title>
        <Subtitle>
          We’ll email you a $100 gift card of your choice after you’ve
          registered and we’ve verified your business.
        </Subtitle>
      </TextWrapper>
      <MobileIconWrapper>
        <Icon name="small-cards-96" color="#8F978C" />
      </MobileIconWrapper>
      <DesktopIconWrapper>
        <Icon name="gift-cards-203" color="#8F978C" />
      </DesktopIconWrapper>
    </OuterWrapper>
  );
}

export default Incentive;
